import { render, staticRenderFns } from "./VoucherRoute.vue?vue&type=template&id=58c4c0fd&scoped=true&"
import script from "./VoucherRoute.vue?vue&type=script&lang=js&"
export * from "./VoucherRoute.vue?vue&type=script&lang=js&"
import style0 from "./VoucherRoute.vue?vue&type=style&index=0&id=58c4c0fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c4c0fd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VContainer,VDataTable,VIcon})
